import { useEffect, useState } from 'react'
import {
  connect as connectToWebSocket,
  disconnect as disconnectFromWebSocket,
  isConnected as isWebSockedConnected,
  onConnectObservable,
  onDisconnectObservable
} from 'services/SocketClient'
import { useAuth } from 'context/auth'

export const useWebSocketConnection = () => {
  const [isConnected, setConnected] = useState(isWebSockedConnected())

  useEffect(() => {
    const onConnectSub = onConnectObservable.subscribe(() => setConnected(true))
    const onDisconnectSub = onDisconnectObservable.subscribe(() => setConnected(false))
    setConnected(isWebSockedConnected())

    return () => {
      onConnectSub.unsubscribe()
      onDisconnectSub.unsubscribe()
    }
  }, [])

  return isConnected
}

export const WebSocketConnectionProvider = ({ children }) => {
  const { authTokens } = useAuth()

  useEffect(() => {
    if (authTokens) {
      connectToWebSocket(authTokens)
    } else {
      disconnectFromWebSocket()
    }
  }, [authTokens])

  return children
}

export default useWebSocketConnection
